export default {
  en: {
    nameLabel: 'Name',
    nameRequired: 'Enter a name',
    iconLabel: 'Icon',
  },
  ru: {
    nameLabel: 'Название',
    nameRequired: 'Введите название',
    iconLabel: 'Иконка',
  },
};
